export const PICTURES = {
  LOAD: 'PICTURES_LOAD',
  LOAD_DONE: 'PICTURES_LOAD_DONE',
  LOAD_FAILED: 'PICTURES_LOAD_FAILED',
  UPLOAD: 'PICTURES_UPLOAD',
  UPLOAD_DONE: 'PICTURES_UPLOAD_DONE',
  UPLOAD_FAILED: 'PICTURES_UPLOAD_FAILED',
  REMOVE_UPLOADED: 'PICTURES_REMOVE_UPLOADED',
  REMOVE_UPLOADED_DONE: 'PICTURES_REMOVE_UPLOADED_DONE',
};

export const load = (entity, id, page) => ({ type: PICTURES.LOAD, entity, id, page });

export const uploadPicture = (file, lessonId) => ({
  type: PICTURES.UPLOAD_MULTIPLE, file, lessonId,
});

export const removePicture = (storageId, pictureId) => ({
  type: PICTURES.REMOVE_UPLOADED, storageId, pictureId,
});



// WEBPACK FOOTER //
// ./src/actions/pictures.js